import React from "react";
import "./button.scss"; // 👈 import SCSS

export default function Button({
  children,
  onClick,
  variant = "default",
  size = "md",
  className = "",
  ...props
}) {
  return (
    <button
      onClick={onClick}
      className={`btn btn-${variant} btn-${size} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
